import axios from 'axios'

const instance = axios.create({
    baseURL: 'http://api.miaoduke.cn',
    timeout: 10000
})

export default instance;



// WEBPACK FOOTER //
// ./src/api/index.js